import manifest from "./screens.figr.json";

type ScreenState = Record<string, unknown>;

interface ScreenEntry {
  name: string;
  route: string;
  section?: string;
  state?: ScreenState;
}

/**
 * Reads `?figr_screen=<id>` and returns that screen's seed state from
 * screens.figr.json, so multi-state UIs can hydrate into a named state.
 */
export function useScreenInit(): ScreenState {
  if (typeof window === "undefined") return {};
  const id = new URLSearchParams(window.location.search).get("figr_screen");
  if (!id) return {};
  const screens = (manifest as { screens: Record<string, ScreenEntry> }).screens;
  return screens?.[id]?.state ?? {};
}
